/** Largura máxima auto-calculada por coluna antes de capar (px). */
export const AUTO_WIDTH_MAX_PX = 160;

/** Grid template do carrinho modal. */
export const CART_GRID_COLS = '1fr 80px 90px 70px 130px 36px';

/** Default e min do split entre tabela e DetailPanel. */
export const DEFAULT_SPLIT_RATIO = 0.62;
export const MIN_DETAIL_PX = 320;
